import React from "react"
import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import DialogActions from "@material-ui/core/DialogActions"
import DialogTitle from "@material-ui/core/DialogTitle"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import ProductsForm from '../forms/maintenance/ProductsForm'
import UsersForm from '../forms/maintenance/UsersForm'
import ParametersForm from '../forms//maintenance/ParametersForm'
import TemplatesForm from '../forms/templates/TemplatesForm'

export default function FormModal(props) {

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }))


  return (
    <>
      <BootstrapDialog
        onClose={props.handleCloseModal}
        aria-labelledby="customized-dialog-title"
        open={props.isOpen}
        fullWidth={true}
        maxWidth={props.maxWidth ? 'lg' : 'sm'}
      >
        <DialogTitle id="customized-dialog-title">
          {props.header}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={props.handleCloseModal}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <form action="/" method="POST" onSubmit={(e) => { props.handledSave(e) }}>
          <DialogContent dividers>
            {
              props.opt === 'products' ?
                <ProductsForm formData={props.formData} />
                : props.opt === 'users' ?
                  <UsersForm formData={props.formData} />
                  : props.opt === 'parameters' ?
                    <ParametersForm formData={props.formData} />
                    : props.opt === 'templates' ?
                      <TemplatesForm formData={props.formData} />
                      : null
            }
          </DialogContent>

          {props.button
            &&
            <DialogActions>
              <Button autoFcus type="submit">
                {props.button}
              </Button>
            </DialogActions>
          }
        </form>
      </BootstrapDialog>
    </>
  )
}
